import styled from 'styled-components';

export const ShopByBrandsStyled = styled.div`
  .ePharmacy {
    .link {
      color: ${(props) => props.theme.green.dark};

      &:hover {
        color: ${(props) => props.theme.green.light};
      }
    }
  }

  .sectionBox {
    padding: ${(props) => (!props.title ? (props.viewAll ? '16px 0 2px 0' : '25px 0 2px 0') : '0 0 16px 0')};
  }

  .slick-slider {
    margin: ${(props) => (!props.title && !props.viewAll ? '-8px 0 16px 0' : !props.title ? '8px 0 20px 0' : '-8px 0 0 0')};

    .slick-list {
      width: 100%;
      margin: 0;
    }
  }

  .brandItemBox {
    width: 100%;
    cursor: pointer;
    .item {
      width: calc(100% - 15px);
      margin: 0 7px 0 8px;
      padding: 15px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .img {
      width: 140px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        position: relative !important;

        > img {
          width: 100% !important;
          height: 100% !important;
          max-width: 140px !important;
          max-height: 60px !important;
          position: relative !important;
          min-width: 80px !important;
        }
      }
    }
  }

  @media (max-width: 820px) {
    .container {
      padding: 16px 0 32px 0;
    }

    .slick-slider {
      margin: 0;
    }
  }

  @media (max-width: 480px) {
    .slick-slide {
      width: 37vw !important;
    }
  }
`;
